import { Controller } from "@hotwired/stimulus"
import { isOfflineFirst, offlineFirstPlaceIds } from "../field_place_connectivity"

// Display-only "Saved data - sync pending" indicator (card #4310, slice 4).
// Shown while a place is latched into offline-first page loads -- see
// field_place_connectivity.js and field_place_connectivity_controller.js for
// the tracking/latching logic this only reads.
//
// Deliberately NOT data-turbo-permanent (unlike the tracking controller):
// it has no state of its own, just a fresh read of sessionStorage on every
// connect, so a plain reconnect on each page load is correct and simpler.
//
// Two uses:
//   - Place show page: placeId value set -> shows when THIS place is latched.
//   - Today page: no placeId value -> shows when ANY place is latched this
//     visit (Today lists every place at once, so it isn't itself place-scoped).
//
// The controller's own element IS the badge -- toggles its own `hidden`
// attribute, matching the plain non-building style of the other small field
// badges (e.g. field_bad_connectivity_controller.js's status badge).
//
// Values:
//   placeId -- optional Place#id to check specifically

export default class extends Controller {
  static values = { placeId: Number }

  connect() {
    this._update()

    this._handler = () => this._update()
    window.addEventListener("field:health-changed", this._handler)
    window.addEventListener("field:offline-first-changed", this._handler)
  }

  disconnect() {
    window.removeEventListener("field:health-changed", this._handler)
    window.removeEventListener("field:offline-first-changed", this._handler)
  }

  _update() {
    const show = this.hasPlaceIdValue
      ? isOfflineFirst(this.placeIdValue)
      : offlineFirstPlaceIds().length > 0

    this.element.hidden = !show
  }
}
